import { BankOutlined, HomeOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '../../constants/routes';
import { useAuth } from '../../contexts/AuthContext';
import { canCreatePersonalOrganization } from '../../utils/authAccess';
import { userHasPersonalOrganization } from '../../utils/organization';

/**
 * وقتی کاربر عادی سازمان فعال ندارد — قبل از صفحات وابسته به tenant.
 */
export default function NoActiveOrganizationState({ title = 'سازمان فعال انتخاب نشده' }) {
  const navigate = useNavigate();
  const { user, organizations } = useAuth();

  const canCreatePersonal =
    canCreatePersonalOrganization(user) && !userHasPersonalOrganization(organizations);
  const hasOrgs = Array.isArray(organizations) && organizations.length > 0;

  let subTitle = 'برای استفاده از این بخش، از منوی کناری یک سازمان را به‌عنوان فضای کاری فعال انتخاب کنید.';
  if (!hasOrgs && canCreatePersonal) {
    subTitle =
      'هنوز فضای کاری ندارید. می‌توانید فضای کاری شخصی خود را بسازید و مدیریت کنید.';
  }

  const extra = !hasOrgs && canCreatePersonal ? (
    <Button
      type="primary"
      icon={<HomeOutlined />}
      className="!rounded-lg !border-0 !bg-brand-gradient"
      onClick={() => navigate(ROUTES.PERSONAL_WORKSPACE_NEW)}
    >
      ایجاد فضای کاری شخصی
    </Button>
  ) : hasOrgs ? (
    <Button type="primary" className="!rounded-lg" onClick={() => navigate(ROUTES.PROFILE)}>
      رفتن به پروفایل
    </Button>
  ) : (
    <Button type="primary" className="!rounded-lg" onClick={() => navigate(ROUTES.PROFILE)}>
      رفتن به پروفایل
    </Button>
  );

  return (
    <Result
      icon={<BankOutlined className="!text-brand-500" />}
      title={title}
      subTitle={subTitle}
      extra={extra}
    />
  );
}
